module.exports = __webpack_public_path__ + "img/zzf_chart_title.8e4fb98b.png";